<template>
  <div class="accountMine">
    <van-row class="banner">
      <van-col span="24">
        <van-row class="user-image">
          <img class="user-icon" :src="wxAvatar" alt="">
        </van-row>
        <van-row>
          <div class="company-name">
            <span>{{staffName}}</span>
          </div>
        </van-row>
      </van-col>
    </van-row>
    <van-row class="serviceinfo">
      <van-col span="24" class="serviceinfoCol">
        <template v-if="isShowIndex">
          <van-row class="serviceinfoRow">
            <van-col span="2" class="serviceinfoRowCol lh37">
              <i class="iconfont icon-company fs24 primary"></i>
            </van-col>
            <van-col span="6" class="serviceinfoRowCol">
              <div class="leftText">所属公司</div>
            </van-col>
            <van-col span="16"  class="serviceinfoRowCol">
              <div class="rightText row-height">{{accCompanyName}}</div>
            </van-col>
          </van-row>
          <van-row class="serviceinfoRow">
            <van-col span="2" class="serviceinfoRowCol lh37">
              <i class="iconfont icon-bumen fs24"></i>
            </van-col>
            <van-col span="6" class="serviceinfoRowCol">
              <div class="leftText row-height">所属部门</div>
            </van-col>
            <van-col span="16"  class="serviceinfoRowCol">
              <div class="rightText row-height">{{departmentName}}</div>
            </van-col>
          </van-row>
          <van-row class="serviceinfoRow specRow">
            <van-col span="2" class="serviceinfoRowCol lh37">
              <i class="iconfont icon-role fs24 "></i>
            </van-col>
            <van-col span="6" class="serviceinfoRowCol">
              <div class="leftText">角色</div>
            </van-col>
            <van-col span="16" class="serviceinfoRowCol">
              <div class="rightText row-height">{{roleValue}}</div>
            </van-col>
          </van-row>
          <van-row class="serviceinfoRow" v-if="origin === 'public'">
            <van-col span="2" class="serviceinfoRowCol lh37">
              <i class="iconfont iconweixinshoukuan fs24"></i>
            </van-col>
            <van-col span="10" class="serviceinfoRowCol">
              <div class="leftText row-height">微信收款服务</div>
            </van-col>
            <van-col span="12"  class="serviceinfoRowCol" @click.native="linkSkip((applyStatus > -1  ? 'applyRate' : 'applyCollection'),{},'','70000008')">
              <div class="rightText row-height">
                <span>{{applyRate}}<van-icon name="arrow"/></span>
              </div>
            </van-col>
          </van-row>
          <van-row class="serviceinfoRow specRow">
            <van-col span="2" class="serviceinfoRowCol lh37">
              <i class="iconfont icondingdan fs24"></i>
            </van-col>
            <van-col span="6" class="serviceinfoRowCol">
              <div class="leftText">我的收款</div>
            </van-col>
            <van-col span="16" class="serviceinfoRowCol" @click.native="linkSkip('acctOrder',{},'','70000009')">
              <div class="rightText row-height"><van-icon name="arrow"/></div>
            </van-col>
          </van-row>
          <van-row class="serviceinfoRow specRow">
            <van-col span="2" class="serviceinfoRowCol lh37">
              <i class="iconfont iconxingouhetong fs24"></i>
            </van-col>
            <van-col span="6" class="serviceinfoRowCol">
              <div class="leftText">我的合同</div>
            </van-col>
            <van-col span="16" class="serviceinfoRowCol" @click.native="linkSkip('myContract',{},'','')">
              <div class="rightText row-height"><van-icon name="arrow"/></div>
            </van-col>
          </van-row>
          <van-row class="serviceinfoRow specRow">
            <van-col span="2" class="serviceinfoRowCol lh37">
              <span class="block security_blue"><img src="../../assets/images/icon-cloudMsg.png" alt=""></span>
            </van-col>
            <van-col span="7" class="serviceinfoRowCol">
              <div class="leftText">云托管短信</div>
            </van-col>
            <van-col span="15" class="serviceinfoRowCol" @click.native="linkSkip('cloudHosting',{},'','')">
              <div class="rightText row-height"><van-icon name="arrow"/></div>
            </van-col>
          </van-row>
          <!-- <van-row class="serviceinfoRow specRow">
            <van-col span="2" class="serviceinfoRowCol">
              <img src="../../assets/images/bannerIcon/yearData.png" />
            </van-col>
            <van-col span="6" class="serviceinfoRowCol">
              <div class="leftText">年度账单</div>
            </van-col>
            <van-col span="16" class="serviceinfoRowCol" @click.native="linkSkip('yearIndex',{},'','')">
              <div class="rightText row-height"><van-icon name="arrow"/></div>
            </van-col>
          </van-row> -->
        </template>


        <template v-if="isShowAuth">
          <van-row class="serviceinfoRow">
            <van-col span="2" class="serviceinfoRowCol lh37">
              <i class="iconfont iconfont-myfont icondianhuaxian fs24" style="color:#00D6F0"></i>
            </van-col>
            <van-col span="6" class="serviceinfoRowCol">
              <div class="leftText row-height">手机号</div>
            </van-col>
            <van-col span="16"  class="serviceinfoRowCol">
              <div class="rightText row-height">{{taxPhone}}</div>
            </van-col>
          </van-row>
        </template>
      </van-col>
    </van-row>
    <div class="logout" @click="logout()">退出登录</div>
    <van-tabbar v-model="active" active-color="#1FADF6">
      <van-tabbar-item class="tac" to="/accountHome" v-if="isShowIndex">
        <span class="block security_blue"><img src="../../assets/images/icon-home.png" alt=""></span>
<!--        <i class="iconfont  block mb5" :class="active == 0 ? 'icon-home_light' : 'icon-home'"></i>-->
        <span class="block">首页</span>
      </van-tabbar-item>
      <van-tabbar-item class="tac" to="/taxauth" v-if="isShowAuth">
        <span class="block security_blue"><img src="../../assets/images/icon-security.png" alt=""></span>
<!--        <i class="iconfont iconfont-myfont iconshuiwu block mb5"></i>-->
        <span class="block">报税授权</span>
      </van-tabbar-item>
      <van-tabbar-item class="tac" to="/accountMine">
        <span class="block security_blue"><img src="../../assets/images/mine_blue.gif" alt=""></span>
<!--        <i class="iconfont icon-mine_light block mb5"></i>-->
        <span class="block">我的</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import { Tabbar, TabbarItem, Row, Col, Icon, Toast  } from "vant";
import awatarImg from "@/assets/images/defaultAwatar.png"

Vue.use(Tabbar).use(TabbarItem).use(Row).use(Col).use(Icon);
export default {
name:"accountMine",
components: {
},
data() {
    return {
      active: 1,
      staffName:'',
      accCompanyName:'',
      departmentName: '',
      roleValue: false,
      wxAvatar:this.$store.state.userInfo.avatar || awatarImg,
      applyStatus: -1,
      origin: '',
      isShowIndex: true,
      isShowAuth: false,
      taxPhone: ''
    }
  },
  mounted() {
    //报税按钮在有报税权限
    if (window.sessionStorage.getItem('taxAuth') && window.sessionStorage.getItem('taxAuth') !== '{}') {
      if (JSON.parse(window.sessionStorage.getItem('taxAuth')).gjAuth === 'noID') {
        this.isShowIndex = false
        if (JSON.parse(window.sessionStorage.getItem('taxAuth')).phone) {
          this.active = 1
          this.isShowAuth = true
          this.taxPhone = JSON.parse(window.sessionStorage.getItem('taxAuth')).phone
        }
      } else {
        this.isShowIndex = true
        this.origin = window.sessionStorage.getItem('origin')
        this.getServiceInfo();
        this.$root.$emit('log-record', "60010097");
        this.getApplyStatus();
        //改变body底色
        document.getElementsByTagName("body")[0].style.backgroundColor = "#F9FBFC";
        if (JSON.parse(window.sessionStorage.getItem('taxAuth')).phone) {
          this.active = 2
          this.isShowAuth = true
          this.taxPhone = JSON.parse(window.sessionStorage.getItem('taxAuth')).phone
        } else {
          this.active = 1
        }
      }
    } else {
      this.origin = window.sessionStorage.getItem('origin')
      this.getServiceInfo();
      this.$root.$emit('log-record', "60010097");
      this.getApplyStatus();
      //改变body底色
      document.getElementsByTagName("body")[0].style.backgroundColor = "#F9FBFC";
    }
  },
  computed: {
    applyRate() {
      let rate = ''
      switch (this.applyStatus) {
        case -1:
          rate = '未开通'
          break;
        case 0:
          rate = '审核中'
          break;
        case 1: 
          rate = '审核中'
          break;
        case 2: 
          rate = '已开通'
          break;
        case 3: 
          rate = '审核不通过'
          break;
      }
      return rate
    }
  },
  methods: {
    linkSkip(name, params, redType, rid) {
      if (rid) {
        this.$root.$emit("log-record", rid);
      }
      this.$router.push({
        name: name,
        query: params
      });
    },
    logout () {
      this.$root.$emit('log-record',"60010099");
      Toast.loading({mask: true,message: '退出中...'});
      let eid = window.sessionStorage.getItem('eid')
      this.$http.get('/mini/user/logout?eid=' + eid).then(res => {
        Toast.clear()
        if (res.data.code == 200) {
          // window.sessionStorage.removeItem('eid')
          window.localStorage.setItem('taxAuthPhone', '')
          this.$store.dispatch('logout')
          this.$router.push({
            name: 'login'
          })
        }
      })
    },
    getServiceInfo () {
      this.$http.get('/fc/small/program/staffbaseinfo').then(res => {
        console.log(res,'/fc/small/program/staffbaseinfo')
        if (res.data.code == 200) {
          let result = res.data.data
          this.staffName = result.staffName
          this.accCompanyName = result.accCompanyName
          this.departmentName = result.departmentName
          this.roleValue = result.roleValue
          window.localStorage.setItem('staffNameInfo', result.staffName)
        }
      })
    },
    getApplyStatus(){
      // eslint-disable-next-line no-unused-vars
      let eid = window.sessionStorage.getItem('eid')
      this.$http.get('/ommall/wechat/serviceprovider/applyinfo?eid=' + eid).then(res=>{
        if (res.data.code == 200) {
          let data = res.data.data
          if (data) {
            this.applyStatus = data.applyStatus
          }
        }
      })
    }
  },
  beforeDestroy(){
    //还原body底色
    document.getElementsByTagName("body")[0].style.backgroundColor = "#f0f2f2";
  }
};
</script>
<style lang="stylus" scoped>
.accountMine{
  .iconfont.block.mb5{
    font-size:0.22rem;
  }
  padding-bottom: 0.62rem;
  overflow: auto;
  .security_blue {
    width: 0.25rem;
    height: 0.25rem;
    margin: 0 auto 0.02rem auto;
  }
  .security_blue img {
    width: 0.25rem;
    height: 0.25rem;
  }
  .banner{
    height:2.42rem;
    background:url('../../assets/images/customer/mineBg.png') center no-repeat;
    background-size:cover;
    color:#ffffff;
    padding:0.12rem;
    .user-image {
      margin: 0 auto;
      text-align: center;
      margin-top: 0.16rem;
      width: 0.88rem;
      height: 0.88rem;
      border-radius: 0.44rem;
      line-height: 0.88rem;
      background: rgba(255,255,255,0.3);
    }
    .user-icon {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 0.4rem;
      margin-top: 0.04rem;
    }
    .company-name {
      text-align: center;
      font-size: 0.16rem;
      font-weight: bold;
      margin-top: 0.06rem;
    }
  }
  .serviceinfo{
    margin: 0 0.12rem;
    // border: 1px solid #E6EBF0;
    box-shadow:0px 2px 8px 0px rgba(44,62,80,0.1);
    border-radius: 8px;
    margin-top: -1.04rem;
    background-color:#ffffff;
    padding:0 0.12rem;
    .serviceinfoRowCol {
      font-size: 0.16rem;
      span {
        float: right;
      }
    }
    .title{
        font-size:0.16rem;
        color:#516374;
      }
    .serviceinfoRow{
      padding:0.08rem 0;
      border-bottom: 1px solid #e6ebf0;
      img{
        height:0.22rem;
        width:0.22rem;
        margin-top: 0.075rem;
      }
      .stitle{
        font-size:0.14rem;
        color:#2C3E50;
      }
      .stitleDesc{
        color:#8896A4;
        font-size:0.12rem;
      }
      .leftText {
        line-height:0.37rem;
        margin-left:0.12rem;
      }
      .rightText{
        text-align:right;
        color:#516374;
        font-size:0.14rem;
        position relative
        .van-icon-arrow:before{
          position: relative;
          top: 0.02rem;
        }
      }
    }
    .serviceinfoRow:last-child{
      border-bottom:none;
    }
    .specRow{
      padding-bottom:0.08rem;
    }
    .serviceinfoInvest.serviceinfoRow{
      padding-bottom 0;
    }
  }
  .row-height {
    height: 0.37rem;
    line-height: 0.37rem;
  }
  .logout {
    background-color: #fff;
    width: 3.51rem;
    height: 0.44rem;
    line-height: 0.44rem;
    text-align: center;
    -webkit-box-shadow: 0px 2px 8px 0px rgba(44,62,80,0.1);
    box-shadow: 0px 2px 8px 0px rgba(44,62,80,0.1);
    border-radius: 0.22rem;
    color: #8896a4;
    font-size: 0.16rem;
    margin-left: 0.12rem;
    margin-top: 0.16rem;
  }
  .phoneNumber{
    text-align:right;
    padding-right:0.26rem;
    position: relative;
    top: -0.18rem;
    color: #8896A4;
    font-size: 0.12rem;
  }
  .icon-phone.phone{
    font-size:0.18rem;
  }
}
</style>

